import { render, staticRenderFns } from "./CompaniesDropdown.vue?vue&type=template&id=91f46158&scoped=true&"
import script from "./CompaniesDropdown.vue?vue&type=script&lang=ts&"
export * from "./CompaniesDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CompaniesDropdown.vue?vue&type=style&index=0&id=91f46158&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f46158",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixLink: require('/root/project/frontend/src/components/BixLink.vue').default,BixImg: require('/root/project/frontend/src/components/images/BixImg.vue').default})
